<template>
    <div>
        <b-card no-body class="w-100 mb-4 mt-3 pl-0">
            <template #header>
                <b-row class="w-100 no-gutters align-items-center flex-nowrap">
                    <b-col md="6">
                        <div class="property-title-container">
                            <span v-if="techInfo.property.thumbnail != null"
                                ><img
                                    class="property-thumbnail"
                                    :src="techInfo.property.thumbnail"
                            /></span>
                            <span class="property-name">
                                <b>{{ techInfo.property.name }}</b>
                            </span>
                        </div>
                    </b-col>
                    <b-col
                        md="6"
                        v-if="!isCancelled"
                        class="reservation-deposit-container"
                    >
                        <span class="float-right reservation-deposit">
                            Reservation Deposit =
                            <span>
                                <a>{{ getReservationDepositValue() }}</a>
                            </span>
                            <span v-if="!techInfo.deposit_is_flat">
                                = {{ techInfo.payment_deposit }}</span
                            >
                        </span>
                    </b-col>
                </b-row>
            </template>
            <b-card-body v-if="!isCancelled">
                <b-row class="no-gutters">
                    <b-col md="12">
                        <invoice-print-table
                            :values="techInfo.chosen_services"
                            :columns="servicesColumnsDef"
                            emptyText="No Services"
                        />
                    </b-col>
                </b-row>
                <b-row class="no-gutters" v-if="!metaReservation.tax_exemption">
                    <b-col md="12">
                        <invoice-print-table
                            :values="techInfo.reservation_taxes"
                            :columns="taxesColumnsDef"
                            emptyText="No Taxes"
                        />
                    </b-col>
                </b-row>
                <b-row class="no-gutters">
                    <b-col md="12">
                        <invoice-print-table
                            :values="techInfo.deposit_payments"
                            :columns="depositsColumnsDef"
                            emptyText="No Deposits"
                        />
                    </b-col>
                </b-row>

                <b-row class="no-gutters">
                    <b-col md="12">
                        <invoice-print-table
                            :values="techInfo.reservation_discounts"
                            :columns="discountColumnsDef"
                            emptyText="No Discounts"
                        />
                    </b-col>
                </b-row>

                <b-row class="no-gutters">
                    <b-col md="12">
                        <invoice-print-table
                            :values="techInfo.additional_fees"
                            :columns="additionalFeesColumnsDef"
                            emptyText="No Fees"
                        />
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Decimal } from 'decimal.js';
import InvoicePrintTable from './invoice-print-table.vue';
import { toAmountDisplay } from '../../../../utils/numbers';

export default {
    props: {
        initialValues: {
            type: Object,
            default: () => ({}),
        },
    },
    components: { InvoicePrintTable },
    data() {
        return {
            metaReservation: this.initialValues.meta_reservation,
            techInfo: this.initialValues.tech_info,
        };
    },
    computed: {
        ...mapGetters('header', [
            'userToday',
            'userUnicodeDateFormat',
            'userCurrencySymbol',
        ]),
        isCancelled() {
            return (
                this.metaReservation.reservation_status.state === 'CANCELLED'
            );
        },
        servicesColumnsDef() {
            return [
                {
                    label: 'Services',
                    key: 'title',
                },
                {
                    label: 'Qty',
                    key: 'count',
                },
                {
                    label: 'Value',
                    key: 'price',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
                {
                    label: 'Amount',
                    key: 'payment_amount',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
            ];
        },
        taxesColumnsDef() {
            return [
                {
                    label: 'Taxes',
                    key: 'title',
                },
                {
                    label: 'Value',
                    key: 'calculated_value',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                    formatter: (value) =>
                        toAmountDisplay({ percentage: true, amount: value }),
                },
                {
                    label: 'Amount',
                    key: 'money',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
            ];
        },
        depositsColumnsDef() {
            return [
                {
                    label: 'Deposits',
                    key: 'title',
                },
                {
                    label: 'Amount',
                    key: 'total_net',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                    formatter: (value) => {
                        return toAmountDisplay({
                            amount: value,
                            currency: this.userCurrencySymbol,
                        });
                    },
                },
            ];
        },
        discountColumnsDef() {
            return [
                {
                    label: 'Discounts',
                    key: 'title',
                },
                {
                    label: 'Coupon',
                    key: 'total_net',
                },
                {
                    label: 'Amount',
                    key: 'value',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                },
            ];
        },
        additionalFeesColumnsDef() {
            return [
                {
                    label: 'Fees',
                    key: 'title',
                },
                {
                    label: 'Related',
                    key: 'parent',
                    formatter: (value) => value || 'N/A',
                },
                {
                    label: 'Number',
                    key: 'number',
                    formatter: (value) => value || 'N/A',
                },
                {
                    label: 'Taxable',
                    key: 'yesNoColumnNew',
                    formatter: (value) => (value ? 'Yes' : 'No'),
                },
                {
                    label: 'Amount',
                    key: 'total_net',
                    thClass: 'text-right',
                    tdClass: 'text-right',
                    formatter: (value) => {
                        return toAmountDisplay({
                            amount: value,
                            currency: this.userCurrencySymbol,
                        });
                    },
                },
            ];
        },
    },
    methods: {
        getReservationDepositValue() {
            if (this.techInfo.deposit_is_flat) {
                return (
                    this.userCurrencySymbol +
                    Decimal(this.techInfo.payment_deposit_value).toFixed(
                        2,
                        Decimal.ROUND_HALF_EVEN
                    )
                );
            } else {
                return (
                    Decimal(this.techInfo.reservation_deposit_combined).toFixed(
                        2,
                        Decimal.ROUND_HALF_EVEN
                    ) + '%'
                );
            }
        },
    },
    watch: {
        initialValues() {
            this.metaReservation = this.initialValues.meta_reservation;
            this.techInfo = this.initialValues.tech_info;
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.card-header) {
    background-color: #0d47a1 !important;
    color: #fff;
    padding: 10px !important;
    font-weight: bold;
    align-items: center;
    justify-content: left !important;
    min-height: 50px;
    font-size: 14px;
    padding-left: 15px !important;
}

:deep(.reservation-deposit-container) {
    align-items: center;
    display: flex;
    justify-content: right;
}

:deep(.reservation-deposit) {
    font-size: 14px !important;
    font-weight: normal !important;

    .edit-link-container {
        background-color: #fff;
        border-radius: 3px;
        padding: 3px 6px;
        align-items: center;
        display: inline-flex;
        font-weight: bold !important;
    }
}

:deep(.card-body) {
    padding: 0 !important;
}

.property-title-container {
    display: inline-flex;
    align-items: center;
}

.property-thumbnail {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    margin-right: 15px;
}

.property-name {
    font-size: 14px;
    font-weight: bold;
}
</style>